/**
 * The row is crowded when the hang itself scrolls, or when the field
 * scrolls. A shrinking field lets the name paint over the genre while
 * the hang's own box still fits, and that still means the mark should drop.
 */
export function frameworkHangCrowded({
  hangScroll = 0,
  hangClient = 0,
  buttonScroll = 0,
  buttonClient = 0,
} = {}) {
  return hangScroll > hangClient + 1 || buttonScroll > buttonClient + 1;
}

/**
 * Outline header: keep the Framework name readable beside the chat pane.
 * Drop the genre mark before the name is shortened. Restore the mark
 * when the row has room for it again.
 */
export function nextFrameworkHangMode(mode, {
  rowOverflow = false,
  nameOverflow = false,
  sparePx = 0,
  genrePx = 0,
} = {}) {
  if (mode !== 'tight') {
    return rowOverflow ? 'tight' : 'roomy';
  }
  if (!nameOverflow && genrePx > 0 && sparePx >= genrePx) return 'roomy';
  return 'tight';
}

/**
 * A row that flips roomy and tight on the next measure is crowded.
 * Stay tight until the spare room is twice the genre mark, so bringing
 * the mark back cannot overflow the same row and blank the page.
 */
export function hangModeAfterFlip(history, next, {
  sparePx = 0,
  genrePx = 0,
  locked = false,
} = {}) {
  const wide = genrePx > 0 && sparePx >= genrePx * 2;
  if (locked && !wide) {
    return { mode: 'tight', history: history || [], locked: true };
  }
  const flips = [...(history || []), next].slice(-4);
  const last = flips.length - 1;
  const oscillating = flips.length >= 3
    && flips[last] === flips[last - 2]
    && flips[last] !== flips[last - 1];
  if (oscillating && !wide) {
    return {
      mode: 'tight',
      history: flips.slice(0, -1).concat('tight'),
      locked: true,
    };
  }
  return { mode: next, history: flips, locked: false };
}

/**
 * Free pixels that could hold the genre mark.
 * A grown field hides that room inside the button, and a grown row
 * hides it inside the hang. Count both, plus leftover space in the
 * heading, so a wide row can show the mark again.
 */
export function frameworkHangSparePx({
  headingClient = 0,
  headingUsed = 0,
  hangBox = 0,
  hangContent = 0,
  buttonBox = 0,
  buttonContent = 0,
} = {}) {
  const flexSlack = headingClient - headingUsed;
  const hangSlack = Math.max(0, hangBox - hangContent);
  const buttonSlack = Math.max(0, buttonBox - buttonContent);
  return flexSlack + hangSlack + buttonSlack;
}
